import React from "react";
import "./Footer2.css";
import Footer2Line from "./Footer2Line";
import Footer2Main from "./Footer2Main";
const Footer2 = () => {
  return (
    <div className="footer2Container">
      <Footer2Line />
      <Footer2Main/>
    </div>
  );
};

export default Footer2;
